export default {
  GET_ALL: `#graphql
  query getSets($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getSets(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        id,
        order,
        brand,
        products,
        images,
        active
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewSet($set: SetInput!) {
    newSet(input: $set)
    {
      id,
      order
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateSet($id: String!, $setUpdate: SetUpdateInput!) {
    updateSet(id:$id, setUpdate: $setUpdate)
    {
      id
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteSet($id: String!) {
    deleteSet(id:$id)
    {
      id
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/set.js